import React from 'react';

class Browser extends React.Component {
	constructor(props) {
		super(props);
		this.state = {isIE11: false};
	}

	componentDidMount() {
		this.detectBrowser();
	}

	detectBrowser = async () => {
		try {
			const browserDetection = await import('@braintree/browser-detection');
			const ie11 = browserDetection.isIe11();

			this.setState({isIE11: ie11});
		} catch (error) {
			console.error('detectBrowser error', error);
		}
	}

	render() {
		if (!this.state.isIE11) {
			return null;
		}

		return (
			<div className='Browser-detection'>
				<div>
					<img className='Logo' src='/static/logo.png'/>
					<h5>Din webbläsare stödjs ej längre!</h5>
					<p>Din webbläsare har nått sitt bäst föredatum, för att kunna visa denna webbplatsen korrekt vänligen uppdatera till en nyare webbläsare. <br/> <a href='http://outdatedbrowser.com/en'>Här kan du välja en bättre webbläsare</a></p>
				</div>
				<style jsx>
					{`
						.Browser-detection {
							position: fixed;
							top: 0;
							left: 0;
							right: 0;
							bottom: 0;
							width: 100%;
							height: 100%;
							z-index: 1001;
							background-color: white;
						}

						.Browser-detection > div {
							max-width: 50%;
							margin: 0 auto;
							padding: 20px;
						}

						.Browser-detection .Logo {
							max-width: 30%;
							display: block;
							margin: 0 auto;
							margin-bottom: 20px;
						}
					`}
				</style>
			</div>
		);
	}
}

export default Browser;



// WEBPACK FOOTER //
// components/browser.js